<template>
  <div style="width: 100%;">
    <v-row>
      <v-col>
        <v-container fluid style="margin-top: -30px;">
          <v-row>
            <v-col class="d-flex flex-row align-center">
              <v-btn @click="()=>{$router.go(-1)}" text><v-icon>mdi-arrow-left</v-icon></v-btn>
              <h1>Customer Follow Up</h1>
              <v-progress-circular
                  indeterminate
                  color="green"
                  v-if="loader"
                  style="margin-left: 10px;"
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="7">
              <span>
                <h3>Filters</h3>
                <span class="d-flex flex-row">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="filters.startDate"
                          label="Start Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          dense
                          outlined
                          clearable
                          v-bind="attrs"
                          v-on="on"
                      />
                    </template>
                    <v-date-picker
                        v-model="filters.startDate"
                    />
                  </v-menu>
                  <v-btn @click="filters.endDate=filters.startDate" color="warning" small class="mx-2 mt-1"><v-icon>mdi-arrow-right</v-icon></v-btn>
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="filters.endDate"
                          label="End Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          dense
                          outlined
                          clearable
                          v-bind="attrs"
                          v-on="on"
                      />
                    </template>
                    <v-date-picker
                        v-model="filters.endDate"
                    />
                  </v-menu>
                </span>
                <span class="d-flex flex-row mb-2" style="margin-top: -15px;">
                  <v-btn class="mr-2" color="info" @click="dailyRecords">Today</v-btn>
                  <v-btn class="mr-2" color="info" @click="monthlyRecords">This Month</v-btn>
                  <v-btn class="mr-2" color="info" @click="yearlyRecords">This Year</v-btn>
                  <v-btn class="mr-2" color="warning" @click="clearDates">Clear Dates</v-btn>
                </span>
                <span>
                  <v-select style="margin-top: 15px;" clearable outlined dense multiple v-model="filters.outcomes" label="Outcomes" :items="followUpOutcomes"/>
                  <v-btn style="margin-top: -15px;" color="success" @click="getAllData" :loading="pagination.loading">Filter Results</v-btn>
                </span>
              </span>
              <v-data-table
                  :headers="headers"
                  :items="allData"
                  dense
                  :loading="pagination.loading"
                  :items-per-page="30"
                  :footer-props="{
                    itemsPerPageOptions: pagination.pageSizeOptions
                  }"
                  class="elevation-1"
                  @click:row="rowClick"
              >
                <template v-slot:top>
                  <v-text-field
                      v-model="options.search"
                      label="Search..."
                      class="mx-4"
                      clearable
                      @change="getAllData"
                  ></v-text-field>
                </template>
                <template v-slot:item.appointmentType="{ item }">
                  <span>{{appointmentTypes.find(x => x.id===item.Appointments[0].appointmentType)?appointmentTypes.find(x => x.id===item.Appointments[0].appointmentType).name:'Unknown'}}</span>
                </template>
                <template v-slot:item.customerName="{ item }">
                  <span>{{item.firstName+' '+item.lastName}}</span>
                </template>
                <template v-slot:item.customerPhone="{ item }">
                  <span>{{item.phone||'None'}}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip small :color="utils.getAppointmentStatusColor(item.Appointments[0].status)">{{utils.parseAppointmentStatus(item.Appointments[0].status)}}</v-chip>
                </template>
                <template v-slot:item.outcome="{ item }">
                  <span>{{outcomes.find(x => x.id===item.Appointments[0].outcome)?outcomes.find(x => x.id===item.Appointments[0].outcome).name:'Unknown'}}</span>
                </template>
                <template v-slot:item.scheduledFor="{ item }">
                  <span>{{utils.customFormatDate(item.Appointments[0].scheduledFor)}}</span>
                </template>
                <template v-slot:item.numEngagements="{ item }">
                  <span>{{item.engagements.length||0}}</span>
                </template>
                <template v-slot:item.lastFollowUp="{ item }">
                  <span>{{item.followUpLog?(item.followUpLog.length>0?utils.formatDate(item.followUpLog[item.followUpLog.length-1].createdAt, 'withTime'):'None'):'None'}}</span>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="5">
              <span class="d-flex flex-column py-2">
                <span>{{selectedCustomer?`${selectedCustomer.firstName||''} ${selectedCustomer.lastName||''}`:'No Customer Selected'}}</span>
                <span v-if="selectedCustomer">Phone: {{selectedCustomer.phone||''}}</span>
                <span v-if="selectedCustomer && selectedCustomer.email">Email: {{selectedCustomer.email||''}}</span>
              </span>

              <v-card class="my-1 pa-2">
                <h5>All Appointments</h5>
                <div v-if="selectedCustomer" style="max-height: 250px; overflow-y: auto;">
                  <v-card @click="$router.push(`/appointments/view/${app.id}`)" v-for="(app, a) of selectedCustomer.Appointments" :key="a" class="pa-2 mb-2 d-flex flex-column" style="cursor: pointer" outlined>
                    <span class="d-flex flex-row justify-space-between">
                      <span><span><b>ID: </b>{{app.id}}</span> | {{utils.customFormatDate(app.scheduledFor)}}</span>
                      <span class="d-flex flex-row align-center">
                        <v-chip small :color="utils.getAppointmentStatusColor(app.status)">{{utils.parseAppointmentStatus(app.status)}}</v-chip>
                        <span v-if="app.appointmentType" class="ml-1">{{appointmentTypes.find(x => x.id===app.appointmentType)?appointmentTypes.find(x => x.id===app.appointmentType).name:'Unknown'}} |</span>
                        <span v-if="app.outcome" class="ml-1">{{outcomes.find(x => x.id===app.outcome)?outcomes.find(x => x.id===app.outcome).name:'Unknown'}}</span>
                        <v-btn text fab small @click="openAppointmentInformation(app, $event)"><v-icon color="info">mdi-information</v-icon></v-btn>
                      </span>
                    </span>
                    <span v-if="app.notes"><b>Notes: </b>{{app.notes}}</span>
                    <span v-if="app.metadata && app.metadata.sealReason"><b>Outcome Notes: </b>{{app.metadata.sealReason}}</span>
                  </v-card>
                </div>
              </v-card>
              <v-card class="my-1 pa-2">
                <h5>All Engagements</h5>
                <span>
                  <div style="max-height: 250px; overflow-y: auto" v-if="selectedCustomer">
                    <v-card outlined v-for="(app, a) of selectedCustomer.Appointments" :key="a" class="d-flex flex-column px-2 mb-2">
                      <b class="mt-2">Appointment {{app.id}}</b>
                      <span class="ml-3" v-if="!app.AppointmentAssetJoins || app.AppointmentAssetJoins.length===0">No Engagements</span>
                      <v-card outlined class="pa-2 mb-1 ml-3" v-for="(activity, i) of app.AppointmentAssetJoins" :key="i" :color="colors[activityTypes.findIndex(x => x.id===activity.activityType)] || colors[4]">
                        <span class="d-flex flex-row justify-space-between">
                          <span><b>{{getActivityType(activity.activityType)}}  #</b>{{getAssetName(activity.assetId)}}</span>
                          <span>{{utils.formatDate(activity.createdAt, 'withTime')}}</span>
                        </span>
                        <span v-if="activity.metadata && activity.metadata.notes"><b>Notes: </b>{{activity.metadata.notes}}</span>
                      </v-card>
                    </v-card>
                  </div>
                </span>
              </v-card>
              <v-card class="pa-2" v-if="selectedCustomer">
                <h5>Previous Logs</h5>
                <div v-if="selectedCustomer.followUpLogReversed.length>0" style="max-height: 250px; overflow-y: auto;">
                  <v-card v-for="(log, l) of selectedCustomer.followUpLogReversed" :key="l" class="pa-2 mb-2" outlined>
                    <span class="d-flex flex-row justify-space-between">
                      <v-textarea solo background-color="teal lighten-5" readonly :value="log.notes"  dense :rows="1" auto-grow/>
                      <span class="d-flex flex-column ml-1 text-right">
                        <span>{{utils.formatDate(log.createdAt, 'withTime')}}</span>
                        <span>{{lookupUsername(log.createdBy)}}</span>
                      </span>
                    </span>
                  </v-card>
                </div>
                <span v-else>No Logs</span>
                <hr class="my-2">
                <h5>Add New Log</h5>
                <v-textarea auto-grow :rows="1" label="Notes" dense outlined v-model="newLog.notes"/>
                <v-btn color="success" :loading="newLog.loading" :disabled="!newLog.notes.trim()" @click="addFollowUp">Save</v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog v-model="appointmentInformation.isOpen" width="500">
      <v-card class="pt-5">
        <v-card-text v-if="appointmentInformation.data">
          <span class="d-flex flex-column">
            <h3>Appointment {{appointmentInformation.data.id}}</h3>
            <span>
              <v-chip small class="mr-1 mb-1" :color="utils.getAppointmentStatusColor(appointmentInformation.data.status)">{{utils.parseAppointmentStatus(appointmentInformation.data.status)}}</v-chip>
              <v-chip small class="mr-1 mb-1 error " v-if="appointmentInformation.data.metadata && appointmentInformation.data.metadata.firstAppointment && appointmentInformation.data.metadata.firstAppointment==true">First Appointment</v-chip>
              <v-chip small class="mr-1 mb-1 warning " v-else>Returning Appointment</v-chip>
              <v-chip small class="mr-1 mb-1 orange white--text" v-if="appointmentInformation.data.metadata && appointmentInformation.data.metadata.confirmationCallAttempted && appointmentInformation.data.metadata.confirmationCallAttempted==true">Conf. Call Attempted</v-chip>
              <v-chip small class="mr-1 mb-1 teal white--text" v-if="appointmentInformation.data.metadata && appointmentInformation.data.metadata.confirmationCallSuccess && appointmentInformation.data.metadata.confirmationCallSuccess==true">Conf. Call Successful</v-chip>
            </span>
            <b>Customer: {{selectedCustomer.firstName}} {{selectedCustomer.lastName}} | {{selectedCustomer.phone}}</b >
            <b>Gender: {{parseAppointmentGender(appointmentInformation.data.gender)}}</b>
            <b>Wedding Date: {{this.utils.customFormatDate(appointmentInformation.data.weddingDate, "notime")}}</b>
            <b>Booking Type: {{appointmentTypes.find(x => x.id===appointmentInformation.data.appointmentType)?appointmentTypes.find(x => x.id===appointmentInformation.data.appointmentType).name:'Unknown'}}</b>
            <b>Outcome: <span>{{outcomes.find(x => x.id===appointmentInformation.data.outcome)?outcomes.find(x => x.id===appointmentInformation.data.outcome).name:'Unknown'}}</span></b>
            <b>Dealt With By: {{lookupUsername(appointmentInformation.data.dealtWithBy)}}</b>
            <b>Budget: ${{appointmentInformation.data.budget}}</b>
            <b># ofAccompaniments: ${{appointmentInformation.data.occupants}}</b>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="error" @click="closeAppointmentInformation">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  import utils from '../../plugins/helpers'
  import moment from "moment";

  export default {
    data () {
      return {
        signaturePadOptions: {
          penColor: 'black'
        },
        utils: utils,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        findCustomerByPhoneLoader: false,
        newCustomer: {addresses: [], suggestedMatches: []},
        snackObj: {
          color: '',
          text: ''
        },
        rules: {
          required: [v => !!v || 'This field is required.'],
        },
        headers: [
          // { text: 'ID', value: 'id' },
          {text: 'Name', sortable: false, value: 'customerName'},
          {text: 'Phone', sortable: false, value: 'customerPhone'},
          {text: 'Last App. Date', sortable: false, value: 'scheduledFor'},
          {text: 'App. Type', sortable: false, value: 'appointmentType'},
          // {text: 'Status', sortable: false, value: 'status'},
          {text: 'Outcome', sortable: false, value: 'outcome'},
          // {text: '# Eng', sortable: false, value: 'numEngagements'},
          {text: 'Last Follow Up', sortable: false, value: 'lastFollowUp'},
        ],
        genders: [
          {name: "None",id: 0, value: 0},
          {name: "Groom 🤵", id: 1, value: 1},
          {name: "Bride 👰", id: 2, value: 2}
        ],
        editMode: false,
        data: {
          name: "",
          location: "",
          serial: "",
          documentTypes: [],
          data: '',
          metadata: ''
        },
        allData: [],
        singular: "Appointment",
        singularLower: "appointment",
        plural: "Appointments",
        pluralLower: "appointments",

        pagination: {
          loading: false,
          dataCount: 0,
          pageSizeOptions: [10, 15, 30, 50, 100, -1]
        },
        options: {
          search: "",
          sortBy: ['id'],
          sortDesc: [true],
          page: 1,
          itemsPerPage: -1
        },
        updatingRoute: false,
        init: false,

        newLog: {
          loading: false,
          notes: ""
        },

        filters: {
          startDate: null,
          endDate: null,
          outcomes: []
        },

        colors: ['cyan', '#F08080', 'orange', 'lime', 'amber'],
        activityTypes: [],
        assets: [],
        appointmentTypes: [],
        outcomes: [],

        followUpOutcomes: [],

        selectedCustomer: null,
        appointmentInformation: {
          isOpen: false,
          data: null
        },

        customers: [],
        intentions: [],
        dateSchedule: [],
        dateScheduleLoader: false,
      }
    },
    async created(){
      try{
        //used for pagination
        let oldQuery = this.getURLQuery();
        this.options.page = oldQuery.page || 1;
        this.options.itemsPerPage = oldQuery.limit || 30
        this.options.sortBy = [oldQuery.sort || "id"]
        this.options.sortDesc = [oldQuery.order || false]
        this.options.search = oldQuery.search || ""
        this.appointmentSearch = this.options.search;
        //used for pagination end
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    async mounted(){
      try {
        this.init = true;

        this.pagination.pageSizeOptions = this.getGlobalValue("paginationPageLimitsGeneral")?.split(",").map(x => parseInt(x)) || this.pagination.pageSizeOptions;

        let res = await axios.get(`${this.getEndpoint}/api/appointmentTypes`)
        if(res.data.error) throw res.data.error
        this.appointmentTypes = res.data.data

        res = await axios.get(`${this.getEndpoint}/api/activityTypes`)
        if(res.data.error) throw res.data.error
        this.activityTypes = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/assets`)
        if(res.data.error) throw res.data.error
        this.assets = res.data.data

        res = await axios.get(`${this.getEndpoint}/api/appointmentOutcomes`)
        if(res.data.error) throw res.data.error
        this.outcomes = res.data.data

        this.followUpOutcomes = this.getGlobalValue('followUpOutcomes').split(",").map(x => {
          return {text: this.outcomes.find(y => y.id===parseInt(x)).name, value: parseInt(x)};
        });

        let now = new Date();
        let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        let lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        this.filters.startDate = this.utils.parseDate(firstDay);
        this.filters.endDate = this.utils.parseDate(lastDay);

        await this.getAllData();
        this.init = false;
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getEndpoint', 'isAllowed', 'getGlobalValue', 'lookupUsername']),
    },
    watch: {
      $route: {
        handler: async function (current) {
          //used for pagination
          if (this.updatingRoute) return;
          let oldQuery = this.getURLQuery(current.query);
          this.options.page = oldQuery.page || 1;
          this.options.itemsPerPage = oldQuery.limit || 30
          this.options.sortBy = [oldQuery.sort || "scheduledFor"]
          this.options.sortDesc = [oldQuery.order || false]
          this.options.search = oldQuery.search || ""
          //used for pagination end include full watcher
        },
        deep: true
      }
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      rowClick(row){
        row.followUpLogReversed = [...row.followUpLog].reverse();

        this.selectedCustomer = row;
      },
      openAppointmentInformation(app, e){
        e.stopPropagation();

        this.appointmentInformation = {
          isOpen: true,
          data: app
        }
      },
      closeAppointmentInformation(){
        this.appointmentInformation = {
          isOpen: false,
          data: null
        }
      },
      dailyRecords(){
        this.filters.startDate = moment().format("YYYY-MM-DD");
        this.filters.endDate = moment().format("YYYY-MM-DD");
      },
      monthlyRecords(){
        this.filters.startDate = moment().startOf('month').format("YYYY-MM-DD");
        this.filters.endDate = moment().endOf('month').format("YYYY-MM-DD");
      },
      yearlyRecords(){
        this.filters.startDate = moment().startOf('year').format("YYYY-MM-DD");
        this.filters.endDate = moment().endOf('year').format("YYYY-MM-DD");
      },
      clearDates(){
        this.filters.startDate = null;
        this.filters.endDate = null;
      },
      getURLQuery(custom=null){
        let oldQuery = custom? {...custom}: {...this.$route.query};
        if(oldQuery.limit) oldQuery.limit = parseInt(oldQuery.limit);
        if(oldQuery.page) oldQuery.page = parseInt(oldQuery.page);
        if(oldQuery.order) oldQuery.order = oldQuery.order==='true';
        return oldQuery;
      },
      async getAllData(){
        try {
          //used for pagination
          this.pagination.loading = true;
          let paginationData = {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sort: (this.options.sortBy.length>0)?this.options.sortBy[0]:"id",
            order: this.options.sortDesc[0],
            search: this.options.search || '',
            ...this.filters
          }

          let uriFields = Object.keys(paginationData).map(x => {
            return x + "=" + (paginationData[x]!==undefined?encodeURIComponent(paginationData[x]):'')
          }).join("&");
          //used for pagination end

          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/customerFollowUp?${uriFields}`)
          if(res.data.error) throw res.data.error
          this.allData = res.data.data
          
          res = await axios.get(`${this.getEndpoint}/api/customers`)
          if(res.data.error) throw res.data.error;
          this.customers = res.data.data;

          res = await axios.get(`${this.getEndpoint}/api/activityTypes`)
          if(res.data.error) throw res.data.error;
          this.intentions = res.data.data;
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.pagination.loading = false;
        }
      },
      getAssetName(asset){
        let found = this.assets.find(x => x.id===asset);
        return found?found.styleNo:'Unknown';
      },
      getActivityType(activity){
        switch(activity){
          case 2:
            return "Tried"
          case 1:
            return "Viewed"
          case 4:
            return "Purchased"
          default:
            return "Unknown"
        }
      },
      parseAppointmentGender(id){
        if(id===0) return ("None")
        else if(id===1) return ("Male")
        else if(id===2) return ("Female")
      },
      async addFollowUp(){
        try{
          this.newLog.loading = true;

          let log = {
            notes: this.newLog.notes
          }

          let res = await axios.post(`${this.getEndpoint}/api/appointments/addFollowUp/${this.selectedCustomer.id}`, log)
          if(res.data.error) throw res.data.error;
          this.selectedCustomer.followUpLog = res.data.data.followUpLog;
          this.selectedCustomer.followUpLogReversed = [...this.selectedCustomer.followUpLog].reverse();

          this.newLog.notes = "";
        }
        catch (e) {
          console.error(e)
          this.snack(e.msg || e, "error")
        }
        finally {
          this.newLog.loading = false;
        }
      }
    }
  }
</script>
